import CheckIcon from '@mui/icons-material/Check';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';

/** Render a success check when the flag is set, nothing otherwise (#7). */
export const renderCheck = (on: boolean) =>
  on ? <CheckIcon fontSize="small" color="success" aria-hidden /> : null;

/** Solid Include (green) / Exclude (red) action pill, per the OR-6288 design. */
export const DefinitionActionPill = ({ isExcluded }: { isExcluded: boolean }) => {
  const { formatMessage } = useIntl();
  return (
    <Chip
      size="small"
      label={formatMessage({
        id: isExcluded
          ? 'epiChat.conceptGroupPreview.definition.action.exclude'
          : 'epiChat.conceptGroupPreview.definition.action.include',
      })}
      sx={{
        backgroundColor: isExcluded ? 'error.main' : 'success.main',
        fontWeight: 400,
        '& .MuiChip-label': { color: 'common.white' },
      }}
    />
  );
};
